import { gql } from '@apollo/client';

export const SUBMIT_EUDR_DDS_VERIFICATION = gql`
  mutation SubmitEudrDdsVerification(
    $idInput: IdInput!
    $goodsItemSequence: Int
  ) {
    submitEudrDdsVerification(
      idInput: $idInput
      goodsItemSequence: $goodsItemSequence
    ) {
      submittedCount
    }
  }
`;
